import * as React from "react";
import classnames from "classnames";

import { Row, Axis, GetSensorsDataFn, SensorsDataResult, GetGeotabSensorsFn, getSensorsData } from "../../../../rest/Geotab";
import { Button, LinkButton } from "../../../../components/Buttons";
import { sensorsReadingsRoute } from "../../../routes";
import { ListStore } from "../../../flux/Grid/ListStore";
import { FlagStore } from "../../../flux/Flag/FlagStore";
import { ErrorStore } from "../../../flux/Error/ErrorStore";

import { SelectedItemsStore } from "../../../flux/Grid/SelectedItemsStore";
import { EntityType, Sensor } from "../../../../models";
import { LoadSensorsDataCommand } from "../../../components/Pages/Sensor/commands/LoadSensorsDataCommand";
import { ShowSensorsDataCommand } from "../../../components/Pages/SensorsData/commands/ShowSensorsDataCommand";


import { GoogleMapLoader } from "../../../utils/GoogleMapLoader";
import { Command1 } from "../../../../Command";

import { ViewType, Coordinate, TableData, SensorsDataActions } from "./flux";
import { TableView } from "./Table";
import { GoogleMap } from "./GoogleMap";
import { TimeSeriesStore } from "../../../../charts/TimeSeries/flux/TimeSeriesStore";
import { Container } from "../../../Container";
import { Chart } from "../../../../charts/TimeSeries/index";
import { Polyglot } from "../../../../polyglot";
import { Toolbar } from "../../Toolbar/index";
import { NonIsolatedPremise } from "../../NonIsolatedPremise";

const styles = require('./SensorsData.scss');

interface Props
{
    polyglot: Polyglot;
    
    refId: string;
    rows: Row[];
    axes: Axis[];
    tableData: TableData;

    timeSeriesStore: TimeSeriesStore;
    
    view: ViewType;
    hasGeoData: boolean;
    hasChartData: boolean;
    isMapVisible: boolean;
    coordinate: Coordinate;

    className?: string;
}

export class View extends React.Component<Props>
{
    private readonly listStore = new ListStore<Sensor>(s => s.id, EntityType.Sensor);
    private readonly selectedItemsStore = new SelectedItemsStore(this.listStore, EntityType.Sensor);
    private readonly sensorsDataActions = new SensorsDataActions();

    private readonly loadSensrosDataCmd: Command1<string>;
    private readonly sensorsDataShowCmd: Command1<SensorsDataResult>;
    private readonly loadSensorsDataInProgressStore = new FlagStore();
    private readonly toolbarErrorStore = new ErrorStore();
    private readonly alertStore = new FlagStore();
    private readonly sensorDataFilter = {
        Ids: [],
        TimeRange: 'last24h'
    };

    constructor(props: Props){
        super(props);
        this.sensorDataFilter = JSON.parse(localStorage.getItem('sensorDataFilter'));

        const googleMapLoader = new GoogleMapLoader();
        this.sensorsDataShowCmd = new ShowSensorsDataCommand(googleMapLoader, this.alertStore.dispatchToken);

        this.loadSensrosDataCmd = new LoadSensorsDataCommand(
            getSensorsData, 
            () => this.sensorDataFilter.Ids,
                this.sensorsDataShowCmd,
                this.loadSensorsDataInProgressStore.dispatchToken,
                this.toolbarErrorStore.dispatchToken
            );
    }

    render()
    {
        const {
            refId, rows, axes, tableData,
            view,
            hasGeoData, isMapVisible,
            polyglot,
        } = this.props;
        let { coordinate } = this.props;

        const isGraph = view === ViewType.Graph;
        const isTable = view === ViewType.TableAndMap;

        return (
            <div className={classnames(this.props.className, styles.SensorsData)}>
                <Toolbar>
                    <LinkButton leftIcon="download" href={sensorsReadingsRoute(refId)} download>{polyglot.t('sensors_data.btn_excel')}</LinkButton>
                    <Button leftIcon="refresh" onClick={() => this.loadSensrosDataCmd.execute(this.sensorDataFilter.TimeRange)}>{polyglot.t('sensors_data.btn_refresh')}</Button>
                    <div className="btn-group">
                        <Button leftIcon="signal" className={classnames({active: isGraph})} onClick={this.sensorsDataActions.setGraphView} disabled={!this.props.hasChartData}>{polyglot.t('sensors_data.btn_graph')}</Button>
                        <Button leftIcon="list" className={classnames({active: isTable})} onClick={this.sensorsDataActions.setTableView}>{polyglot.t('sensors_data.btn_table')}</Button>
                        <NonIsolatedPremise>
                            {isTable && <Button leftIcon="map-marker" className={classnames({active: isMapVisible})} onClick={this.sensorsDataActions.toggleMap} disabled={!hasGeoData}>{polyglot.t('sensors_data.btn_map')}</Button>}
                        </NonIsolatedPremise>
                    </div>
                </Toolbar>
                { isGraph && (
                    <Container store={this.props.timeSeriesStore}>
                        <Chart polyglot={polyglot} dataSets={null} tooltip={null} zoomedDataSets={null} isRangeOk={isRangeOk}/>
                    </Container>)
                }
                { isTable && (
                    <div className={styles.Container}>
                        <div style={{height: '100%'}}>
                            <div style={{overflowY: 'scroll', height: '100%'}}>
                                <TableView
                                    polyglot={polyglot}
                                    data={tableData}
                                    onClick={row => {
                                        const { lon, lat } = row;
                                        this.sensorsDataActions.setCoordinate(lon, lat);
                                    }}
                                />
                            </div>
                        </div>
                        { isMapVisible && <GoogleMap position={coordinate} defaultZoom={10}/> }
                    </div>
                    )
                }
            </div>
        );
    }
}

function isRangeOk(range: [Date, Date])
{
    const dt = (+range[1]) - (+range[0]);
    return dt >= 60 * 1000;
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/SensorsData/View.tsx